export default __webpack_public_path__ + "static/new7-05-1056d0b3da6a39e17bb1f8597ace9697.jpg";